/**
 * Returns the URL of the assets based on the environment.
 * @returns {string} The URL of the assets.
 */
export function getAssetsUrl() {
  const env = process.env['NEXT_PUBLIC_APP_ENV'] || 'prod'

  return `https://assets.${env}.sylvera.com/src`
}
